import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Checkbox, FormControlLabel, Slider } from '@mui/material';
import { useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { getIssuePriorityNameRu, IssuePriority } from '../data/IssuePriority';

export default function ChangePriorityDialog({ issueId, initialPriorityID, initialIsError, onSubmit, onCancel }: { issueId: number, initialPriorityID: IssuePriority, initialIsError: boolean, onSubmit: (priorityId: IssuePriority, isError: boolean) => void, onCancel: () => void }) {

    const [priorityId, setPriorityId] = useState(initialPriorityID);
    const [isError, setIsError] = useState(initialIsError);

    const { api } = useRootStore();

    const changePriority = async () => {
        await api.updateIssuePriorityID(issueId, priorityId, isError)
            .then(() => onSubmit(priorityId, isError));
    }

    const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsError(event.target.checked);
        if (event.target.checked) {
            setPriorityId(IssuePriority.priority);
        }
    };

    const handleSliderChange = (_event: Event, newValue: number | number[]) => {
        setPriorityId(newValue as number);
    };

    const marks = [
        {
            value: IssuePriority.standard,
            label: getIssuePriorityNameRu(IssuePriority.standard),
        },
        {
            value: IssuePriority.priority,
            label: getIssuePriorityNameRu(IssuePriority.priority),
        },
        {
            value: IssuePriority.critical,
            label: getIssuePriorityNameRu(IssuePriority.critical),
        },
    ]

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Dialog open={true} onClose={onCancel}>
                <DialogTitle>Изменение приоритета задачи</DialogTitle>
                <DialogContent sx={{ minHeight:300 }}>
                    <Box sx={{ mb: 1, ml: 0.2 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //defaultChecked={initialIsError}
                                    checked={isError}
                                    onChange={handleCheckBoxChange}
                                />} label="Ошибка" />
                    </Box>
                    <Box sx={{ height: 130, mt: 5 }}>
                        <Slider
                            aria-label="Проритет"
                            valueLabelDisplay='off'
                            marks={marks}
                            value={priorityId}
                            onChange={handleSliderChange}
                            orientation="vertical"
                            step={1}
                            disabled={isError}
                            min={5}
                            max={7}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel}>Отмена</Button>
                    <Button onClick={changePriority}>Изменить</Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
}